@if (companyName) {
  <div
    fxLayout
    class="padding-right-md padding-left-md margin-bottom-sm"
    >
    <div >
      <span class="shipperLabel" appBlurElement>{{ companyName }}</span>
      <span>
        @if (priority) {
          <mat-icon svgIcon="priority"></mat-icon>
        }
      </span>
    </div>
    <app-offer [quote]="driverQuote" [shipmentOfferRate]="offerRate"> </app-offer>
  </div>
}
@if (companyName) {
  <mat-divider></mat-divider>
}
<div  class="padding-top-md padding-right-md padding-left-md">
  <div class="padding-right-md">
    <span class="locationLabel">PICKUP</span>
    <span class="locationValue padding-top-md" appBlurElement
      >@if (isNativeApp) {
      <a href="#">{{ shipment?.origin }}</a>
    }
    @if (!isNativeApp) {
      <a>{{ shipment?.origin }}</a>
      }</span
      >
      <span class="dateLabel">{{ formattedPickupDateAndTime }}</span>
      <span class="locationLabel padding-top-md">DISTANCE</span>
      <span class="locationValue  padding-top-md">{{ shipment?.distance || '-' }}</span>
      @if (shipment?.mode) {
        <span class="locationLabel padding-top-md">MODE</span>
      }
      <span class="locationValue  padding-top-md">{{ shipment?.mode }}</span>
      <span class="locationLabel padding-top-md">COMMODITY</span>
      <span class="locationValue  padding-top-md">{{ shipment?.commodity || '-' }}</span>
    </div>
    <div class="padding-left-md">
      <span class="locationLabel">DELIVERY</span>
      <span class="locationValue  padding-top-md" appBlurElement
        >@if (isNativeApp) {
        <a href="#">{{ shipment?.destination }}</a>
      }
      @if (!isNativeApp) {
        <a>{{ shipment?.destination }}</a>
        }</span
        >
        <span class="dateLabel">{{ formattedDeliveryDateAndTime }}</span>
        <span class="locationLabel padding-top-md">WEIGHT</span>
        <span class="locationValue  padding-top-md">{{ shipment?.weight }}</span>
      </div>
    </div>
    <div class="padding-top-md padding-right-md padding-left-md">
      <span class="locationLabel padding-top-md">DRIVER ASSISTANCE</span>
      <mat-checkbox class="locationValue padding-top-md" [checked]="shipment?.pickup?.driverAssistedPickup" disabled>
        Pickup</mat-checkbox
        >
        <mat-checkbox
          class="locationValue margin-left-md padding-top-xsm"
          [checked]="shipment?.pickup?.liftgatePickup"
          disabled
          >
          Liftgate Pickup</mat-checkbox
          >
          <mat-checkbox class="locationValue margin-left-md padding-top-xsm" [checked]="shipment?.pickup?.tarpPickup" disabled>
            Tarp Pickup</mat-checkbox
            >
            <mat-checkbox class="locationValue padding-top-sm" [checked]="shipment?.delivery?.driverAssistedDelivery" disabled>
              Delivery</mat-checkbox
              >
            </div>
            <div  class="padding-left-md">
              <div class="padding-right-md">
                <span class="locationLabel padding-top-md">COMMENTS</span>
                <span class="comment">{{ shipment?.comment || 'N/A' }}</span>
              </div>
            </div>
